<template>
  <v-btn
    :href="whatsappLink"
    target="_blank"
    rel="noopener"
    icon
    class="whatsapp-float"
    aria-label="Chat on WhatsApp"
  >
    <v-icon icon="mdi-whatsapp" size="28" />
  </v-btn>
</template>

<script>
export default {
  name: "WhatsAppChat",
  computed: {
    whatsappLink() {
      const phone = "917708805512"; // ✅ Your WhatsApp number (with country code)
      const message = encodeURIComponent(
        "Hi! I need help with your co-ord collection on RKay."
      );
      return `https://wa.me/${phone}?text=${message}`;
    },
  },
};
</script>

<style scoped>
.whatsapp-float {
  position: fixed;
  bottom: 22px;
  right: 22px;
  background-color: #25d366;
  color: #fff;
  /* border-radius: 50%; */
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  z-index: 9999;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.whatsapp-float:hover {
  transform: scale(1.08);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
  color: #fff;
}
</style>
